var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',[_c('Modal',{attrs:{"modal_id":"modal_carousel_images"}},[_vm._l((_vm.images),function(image,key){return [_c('figure',{key:key},[_c('img',{attrs:{"src":image.image,"alt":image.alt}})])]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }